import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["mapContainer", "mapWrapper"];

  static values = {
    apiKey: String,
    latitude: String,
    longitude: String,
    name: String,
  };

  connect() {
    if (!window.mapboxgl) {
      console.error("Mapbox GL JS n'est pas chargé !");
      return;
    }

    window.mapboxgl.accessToken = this.apiKeyValue;

    this.map = new window.mapboxgl.Map({
      container: this.mapContainerTarget,
      style: "mapbox://styles/mapbox/streets-v11",
      center: [this.longitudeValue, this.latitudeValue],
      zoom: 12,
    });

    this.#addMarkersToMap();
  }

  enlargeYourMap(e) {
    e.stopPropagation()
    this.mapWrapperTarget.classList.add("large");
    document.body.classList.add("no-scroll");
    this.map.resize();
  }

  shrinkYourMap() {
    this.mapWrapperTarget.classList.remove("large");
    document.body.classList.remove("no-scroll");
    this.map.resize();
  }

  preventDefault(e) {
    e.stopPropagation();
  }

  #addMarkersToMap() {
    new mapboxgl.Marker()
      .setLngLat([this.longitudeValue, this.latitudeValue])
      .setPopup(new mapboxgl.Popup().setText(this.nameValue))
      .addTo(this.map);
  }
}
